import "../css/PopupDescriptionItem.css";

export default ({ title, text }) => {
  return (
    <div className="popup-row popup-row-description-item">
      <span className="popup-row-description-item-description">{title}:</span>
      <span>{text}</span>
    </div>
  );
};
